import request from '@/utils/request'


/**
 * 半流程招标代理
 **/

// 创建-编辑半流程项目及标段
export const createSemiProcessProjectAndSection = (data) => {
    return request.post('/api/agent/semiProcess/project/add', data)
}
//半流程项目列表
export const Api_GetSemiProcessProjectList = (data) => {
    return request.get('/api/agent/semiProcess/project/list', data)
}
//删除
export const Api_DeleteSemiProcessProject = (projectCode) => {
    return request.post('/api/agent/semiProcess/project/delete?projectCode=' + projectCode)
}
//详情
export const Api_GetSemiProcessProjectDetail = (projectCode) => {
    return request.get('/api/agent/semiProcess/project/detail?projectCode=' + projectCode)
}
// 招标公告列表
export const Api_GetSemiProcessTenderNoticeList = (data) => {
    return request.get('/api/agent/semiProcess/tenderNotice/list', data)
}
// 招标公告详情
export const Api_GetSemiProcessTenderNoticeDetail = (data) => { 
    return request.get('/api/agent/semiProcess/tenderNotice/detail', data)
}
//删除
export const Api_DeleteSemiProcessTenderNotice = (data) => {
    return request.post('/api/agent/semiProcess/tenderNotice/delete?tenderNoticeCode=' + data.tenderNoticeCode)
}
//创建公告费订单并发起扫码支付
export const Api_CreateSemiProcessTenderNoticeOrder = (data) => {
    return request.get('/api/agent/semiProcess/tenderNotice/createOrder/' + data.tenderNoticeCode)
}
//保存
export const Api_SaveSemiProcessTenderNotice = (data) => {
    return request.post('/api/agent/semiProcess/tenderNotice/add', data)
}










/**
 * 半流程投标人
 **/
//招标公告详情
export const Api_GetSemiProcessDetail = (data) => {
    return request.get('/api/bid/semiProcess/detail', data)
}
//招标公告列表
export const Api_GetSemiProcessList = (data) => {
    return request.get('/api/bid/semiProcess/list', data)
}

//中标公告详情
export const Api_GetWinBulletinDetail = (data) => {
    return request.get('/api/bid/semiProcess/winBulletinDetail', data)
}
//中标公告列表
export const Api_GetWinBulletinList = (data) => {
    return request.get('/api/bid/semiProcess/winBulletinList', data)
}
//中标候选人公示详情
export const Api_GetWinCandidateDetail = (data) => {
    return request.get('/api/bid/semiProcess/winCandidateDetail', data)
}
//中标候选人公示列表
export const Api_GetWinCandidateList = (data) => {
    return request.get('/api/bid/semiProcess/winCandidateList', data)
}

//获取标段列表
export const Api_GetSectionList = (data) => {
    return request.get('/api/common/section/list?projectCode=' + data.projectCode)
}






